import { call, put, takeLatest } from 'redux-saga/effects';
import { thongKeApi } from '../../../api/thongKeApi';
import { IThongKeSiSoSelectRequest } from '../../../models/request/thong-ke/IThongKeSiSoSelectRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eThongKeSiSoActionTypeIds, IThongKeSiSoActionTypes } from '../../action-types/thong-ke/IThongKeSiSoActions';
import { actions } from '../../actions/actionsWrapper';
const mainAction = actions.thongKe.thongKeSiSo;

export function* thongKeSiSoSaga(): any {
    yield takeLatest(eThongKeSiSoActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eThongKeSiSoActionTypeIds.LOAD_TRANG_THAI_START, loadTrangThaiWorker)

}

function* loadWorker(action: IThongKeSiSoActionTypes): any {

    const res: IBaseResponeModel = yield call(thongKeApi.ThongKeSiSo, action.payload as IThongKeSiSoSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* loadTrangThaiWorker(action: IThongKeSiSoActionTypes): any {

    const res: IBaseResponeModel = yield call(thongKeApi.ThongKeTrangThai, action.payload as IThongKeSiSoSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_TRANG_THAI_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_TRANG_THAI_ERROR(res.message ?? "Error"))
    }
}
